<nav class="w-full h-[var(--nav-height)] min-h-[var(--nav-height)] bg-[var(--nav-bg)] flex items-center justify-between pl-2 pr-4 lg:pl-3 lg:pr-6 border-b border-[var(--border)] relative z-20">
  <div class="flex items-center min-w-0 flex-1 h-full">
    <a routerLink="/dashboard" class="mr-2 lg:mr-3 shrink-0 flex items-center h-full no-underline">
      <img src="/legal-management-transparent.png" alt="Legal Management" class="h-[42px] w-auto max-w-none object-contain shrink-0" />
    </a>
    <div class="flex items-center gap-1 lg:gap-2 min-w-0 overflow-hidden h-full">
      @for(l of links; track l.path){
      <a [routerLink]="l.path" routerLinkActive="bg-[var(--nav-link-bg-hover)] text-[var(--nav-link-text-active)]" class="px-3 py-2 rounded-[6px] text-[13px] font-medium
               text-[var(--nav-link-text)] whitespace-nowrap shrink-0 inline-flex items-center h-[36px]
               hover:bg-[var(--nav-link-bg-hover)] hover:text-[var(--nav-link-text-active)]
               transition-all duration-200
               no-underline hover:no-underline">
        {{ l.label }}
      </a>
      }
    </div>
  </div>
  <div class="flex items-center gap-3 lg:gap-4 ml-3 lg:ml-6 shrink-0 whitespace-nowrap h-full">
    <!-- Theme toggle button -->
    <button
      type="button"
      (click)="toggleTheme()"
      class="p-2 rounded-lg text-[var(--nav-link-text)] hover:bg-[var(--nav-link-bg-hover)] transition-colors"
      title="Toggle dark mode (Alt+D)">
      <i [class]="isDarkMode ? 'pi pi-sun text-[16px]' : 'pi pi-moon text-[16px]'"></i>
    </button>
    <!-- Profile menu -->
    <div class="flex items-center gap-2 cursor-pointer select-none h-full"
      aria-label="Open profile menu"
      role="button"
      tabindex="0"
      (click)="openProfileMenu($event, profileMenu)"
      (keydown.enter)="openProfileMenu($event, profileMenu)"
      (keydown.space)="$event.preventDefault(); openProfileMenu($event, profileMenu)">
      <div class="w-[34px] h-[34px] rounded-full
               flex items-center justify-center uppercase
               text-white font-semibold text-[12px] shrink-0"
               [style.background]="userAvatarColor">
        {{ userInitials }}
      </div>
      <div class="flex flex-col justify-center leading-tight">
        <span class="text-[var(--nav-user-text)] font-medium text-[13px] whitespace-nowrap">
          {{ auth.getUser()?.name }}
        </span>
        @if (userRole) {
        <span class="text-[var(--nav-link-text)] font-normal text-[11px] whitespace-nowrap">
          {{ userRole }}
        </span>
        }
      </div>
    </div>
  </div>
</nav>
<p-menu #profileMenu [popup]="true" [model]="profileItems" [appendTo]="'body'" styleClass="profile-menu-popup dark:profile-menu-popup-dark"
  [style]="{ width: profileMenuWidth + 'px' }">
</p-menu>